import { render, staticRenderFns } from "./I18nMessageManager.vue?vue&type=template&id=1b29d2f6&scoped=true&"
import script from "./I18nMessageManager.vue?vue&type=script&lang=js&"
export * from "./I18nMessageManager.vue?vue&type=script&lang=js&"
import style0 from "./I18nMessageManager.vue?vue&type=style&index=0&id=1b29d2f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b29d2f6",
  null
  
)

export default component.exports